import { Component, Injector, Optional, Input } from '@angular/core';

import { ProjectService } from 'src/app/core/service/project.service';
import { Project } from 'src/app/core/dto/project';
import { Filter, FilterBuilder, PagedCollectionComponent, ColumnDefinition, createColumnDefinitions, SearchableType } from '@mango/core';
import { Projectgroep } from 'src/app/core/dto/projectgroep';
import { PostType } from 'src/app/core/dto/post-type';
import { Projectstatus } from 'src/app/core/enums/projectstatus';

@Component({
    selector: 'c-i-j-borculo-project-collection',
    templateUrl: './project-collection.component.html'/*,
    styleUrls: ['./project-collection.component.css'] */
})
export class ProjectCollectionComponent extends PagedCollectionComponent<Project> {
    columnDefinitions: ColumnDefinition[] = createColumnDefinitions<Project>([
		{ colDef: 'datumAanvraag', prop: x => x.datumAanvraag, searchable: SearchableType.Date },
		{ colDef: 'code', prop: x => x.code, searchable: SearchableType.String },
		{ colDef: 'relatie', prop: x => x.relatie.naam1, searchable: SearchableType.String },
		{ colDef: 'projectgroep', prop: x => x.projectgroep.omschrijving, searchable: SearchableType.String },
		{ colDef: 'projectstatus', prop: x => x.status, searchable:  { type: SearchableType.Enum, enum: Projectstatus } },
		{ colDef: 'projectleider', prop: x => x.projectleider.naam, searchable: SearchableType.String },
		{ colDef: 'referentieKlant', prop: x => x.referentieKlant, searchable: SearchableType.String },
		{ colDef: 'omschrijving2', prop: x => x.omschrijving2, searchable: SearchableType.String },		
		{ colDef: 'datumOrder', prop: x => x.datumOrder, searchable: SearchableType.Date },
		{ colDef: 'datumOBAangemaakt', prop: x => x.datumOBAangemaakt, searchable: SearchableType.Date },
		{ colDef: 'datumOBVerstuurd', prop: x => x.datumOBVerstuurd, searchable: SearchableType.Date },
		{ colDef: 'datumStart', prop: x => x.datumStart, searchable: SearchableType.Date },
		{ colDef: 'datumPlan', prop: x => x.datumPlan, searchable: SearchableType.Date },
		{ colDef: 'datumGereed', prop: x => x.datumGereed, searchable: SearchableType.Date }
    ]);
    displayedColumns = this.columnDefinitions.map(x => x.colDef);

    constructor(public service: ProjectService, @Optional() protected filter: Filter<Project>, injector: Injector) {
        super('/project/project', injector, Project);

		this.initInput('projectgroep', this.filterBuilder.equal(x => x.projectgroep.id));
		this.orderBy = [-1];

		this.filter.onGetChipLabel(x => x.datumAanvraag, () => 'Datum Aanvraag');
		this.filter.onGetChipLabel(x => x.code, () => 'Code');
		this.filter.onGetChipLabel(x => x.relatie.naam1, () => 'Relatie');
		this.filter.onGetChipLabel(x => x.projectgroep.omschrijving, () => 'Projectgroep');
		this.filter.onGetChipLabel(x => x.status, () => 'Status');
		this.filter.onGetChipLabel(x => x.projectleider.naam, () => 'Projectleider');
		this.filter.onGetChipLabel(x => x.referentieKlant, () => 'Referentie Klant');
		this.filter.onGetChipLabel(x => x.omschrijving2, () => 'Omschrijving');
		this.filter.onGetChipLabel(x => x.datumOrder, () => 'Datum Order');
		this.filter.onGetChipLabel(x => x.datumOBAangemaakt, () => 'Datum Bevestigind');
		this.filter.onGetChipLabel(x => x.datumOBVerstuurd, () => 'Datum Verstuurd');
		this.filter.onGetChipLabel(x => x.datumStart, () => 'Datum Start');
		this.filter.onGetChipLabel(x => x.datumPlan, () => 'Datum Planning');
		this.filter.onGetChipLabel(x => x.datumGereed, () => 'Datum Gereed');
    }

	displayColumn(colDef: ColumnDefinition, ix: number) {
		// Hide columns that are already filtered on
		if(colDef.colDef == 'projectgroep' && this.projectgroep != null) { return false; }

		return super.displayColumn(colDef, ix);
	}

	getStatus(value) {

		switch (Number(value)) {
			case Projectstatus.Order:
				return "Order";
			case Projectstatus.Gereed:
				return "Gereed";
			default:
				return value;
		}
	}

	@Input() set projectgroep(val: Projectgroep) { this.handleInput('projectgroep', val.id); }
}